import { useState, useEffect, Fragment } from 'react';
import FieldNames from '../../../defaults/FieldNames.json';
import HelpIcon from '@mui/icons-material/Help';
import { Typography, IconButton, Popover } from '@mui/material';

export default function DetailsPopover({
    mode,
    field,
    isTreatment,
    categoryValue,
    isPoint,
    isActuals,
    agencyValue,
    isBulkApproval,
}) {
    const [helpPopverOpen, setHelpPopoverOpen] = useState(false);
    const [helperTextItems, setHelperTextItems] = useState(null);
    const [fieldHelperText, setFieldHelperText] = useState();
    const [anchorEl, setAnchorEl] = useState(null);

    const fieldHasHelperText = isTreatment
        ? isActuals
            ? FieldNames.featureFieldsWithHelperText?.includes(field)
            : FieldNames.fieldsWithHelperText?.includes(field)
        : FieldNames.featureFieldsWithHelperText?.includes(field);

    useEffect(() => {
        if (isTreatment) {
            if (isActuals) {
                setHelperTextItems(FieldNames.actualTreatmentHelperTextByField);
            } else {
                setHelperTextItems(FieldNames.helperTextByField);
            }
        } else {
            setHelperTextItems(FieldNames.activityHelperTextByField);
        }
    }, [isTreatment, isActuals, isBulkApproval]);

    useEffect(() => {
        if (mode === FieldNames.modes.edit) {
            let textToSet =
                field &&
                helperTextItems?.[field] &&
                (field !== FieldNames.featureFields.type ||
                    (isPoint === FieldNames.yesNo.yes &&
                        categoryValue === FieldNames.categoriesForChecking.programManagement))
                    ? helperTextItems[field]
                    : '';
            setFieldHelperText(textToSet);
        }
    }, [helperTextItems, field, mode, isPoint, categoryValue]);

    const popoverClick = (event) => {
        setAnchorEl(event.currentTarget);
        setHelpPopoverOpen(true);
    };

    const popoverClose = () => {
        setHelpPopoverOpen(false);
        setAnchorEl(null);
    };

    const popover = () => {
        if (
            field !== FieldNames.featureFields.fundingTribe &&
            fieldHasHelperText &&
            fieldHelperText &&
            mode === FieldNames.modes.edit
        ) {
            return (
                <Fragment>
                    <IconButton
                        style={{ padding: 0 }}
                        aria-label='Help'
                        onClick={(event) => popoverClick(event)}
                    >
                        <HelpIcon fontSize='small' color='primary' style={{ right: '0px' }} />
                    </IconButton>
                    <Popover
                        id={'help-popover-' + field}
                        open={helpPopverOpen}
                        style={{ maxWidth: '580px' }}
                        anchorEl={anchorEl}
                        onClose={popoverClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <div style={{ maxHeight: '300px', overflowY: 'scroll', width: '300px' }}>
                            {fieldHelperText.map((text, i) => (
                                <Typography key={i} sx={{ p: 1 }}>
                                    {text}
                                </Typography>
                            ))}
                        </div>
                    </Popover>
                </Fragment>
            );
        } else if (
            field === FieldNames.featureFields.fundingTribe &&
            fieldHasHelperText &&
            fieldHelperText &&
            mode === FieldNames.modes.edit
        ) {
            if (agencyValue && agencyValue.includes(FieldNames.agencies.bia)) {
                return (
                    <Fragment>
                        <IconButton
                            style={{ padding: 0 }}
                            aria-label='Help'
                            onClick={(event) => popoverClick(event)}
                        >
                            <HelpIcon fontSize='small' color='primary' style={{ right: '0px' }} />
                        </IconButton>
                        <Popover
                            id={'help-popover-' + field}
                            open={helpPopverOpen}
                            style={{ maxWidth: '580px' }}
                            anchorEl={anchorEl}
                            onClose={popoverClose}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <div style={{ maxHeight: '300px', overflowY: 'scroll' }}>
                                {fieldHelperText.map((text, i) => (
                                    <Typography key={i} sx={{ p: 1 }}>
                                        {text}
                                    </Typography>
                                ))}
                            </div>
                        </Popover>
                    </Fragment>
                );
            } else {
                return <Fragment></Fragment>;
            }
        } else if (field === 'export') {
            return (
                <Fragment>
                    <IconButton
                        style={{ padding: 0 }}
                        aria-label='Help'
                        onClick={(event) => popoverClick(event)}
                    >
                        <HelpIcon fontSize='small' color='primary' style={{ right: '0px' }} />
                    </IconButton>
                    <Popover
                        id={'help-popover-' + field}
                        open={helpPopverOpen}
                        style={{ maxWidth: '580px' }}
                        anchorEl={anchorEl}
                        onClose={popoverClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <div style={{ maxHeight: '300px', overflowY: 'scroll' }}>
                            {FieldNames.helperTextBulkApprovals.export.map((text, i) => (
                                <Typography key={i} sx={{ p: 1 }}>
                                    {text}
                                </Typography>
                            ))}
                        </div>
                    </Popover>
                </Fragment>
            );
        } else if (field === 'summary') {
            return (
                <Fragment>
                    <IconButton
                        style={{ padding: 0 }}
                        aria-label='Help'
                        onClick={(event) => popoverClick(event)}
                    >
                        <HelpIcon fontSize='small' color='primary' style={{ right: '0px' }} />
                    </IconButton>
                    <Popover
                        id={'help-popover-' + field}
                        open={helpPopverOpen}
                        style={{ maxWidth: '580px' }}
                        anchorEl={anchorEl}
                        onClose={popoverClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        {isTreatment && !isActuals && (
                            <div
                                style={{ maxHeight: '300px', overflowY: 'scroll', width: '300px' }}
                            >
                                {FieldNames.helperTextSummary.fundingTreatments.map((text, i) => (
                                    <Typography key={i} sx={{ p: 1 }}>
                                        {text}
                                    </Typography>
                                ))}
                            </div>
                        )}
                        {!isTreatment && !isActuals && (
                            <div
                                style={{ maxHeight: '300px', overflowY: 'scroll', width: '300px' }}
                            >
                                {FieldNames.helperTextSummary.fundingActivities.map((text, i) => (
                                    <Typography key={i} sx={{ p: 1 }}>
                                        {text}
                                    </Typography>
                                ))}
                            </div>
                        )}
                        {isTreatment && isActuals && (
                            <div
                                style={{ maxHeight: '300px', overflowY: 'scroll', width: '300px' }}
                            >
                                {FieldNames.helperTextSummary.fundingActualTreatments.map(
                                    (text, i) => (
                                        <Typography key={i} sx={{ p: 1 }}>
                                            {text}
                                        </Typography>
                                    )
                                )}
                            </div>
                        )}
                        {!isTreatment && isActuals && (
                            <div
                                style={{ maxHeight: '300px', overflowY: 'scroll', width: '300px' }}
                            >
                                {FieldNames.helperTextSummary.fundingActualActivities.map(
                                    (text, i) => (
                                        <Typography key={i} sx={{ p: 1 }}>
                                            {text}
                                        </Typography>
                                    )
                                )}
                            </div>
                        )}
                    </Popover>
                </Fragment>
            );
        } else {
            return <Fragment></Fragment>;
        }
    };

    return popover();
}
